import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TTableProps } from './types/index.types';
import { TableModel } from './models/index.model';
import TableComp from './components/table';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const Table = (props: TTableProps) => {
    const model = new TableModel(props);

    if (!model) return null;

    // Component is unreleased
    if (model.isUnreleased) {
        return <UnreleasedComponent/>
    }

    return <TableComp model={model}/>;
};
export default withSitecoreContext()(Table);
